/**
 * Vertraege rund um Authentifizierung und Session.
 *
 * Backend und Frontend teilen sich ausschliesslich diese Definitionen. Das
 * Frontend (AP1.T1.4) baut seinen API-Client darauf auf.
 */
/** Name des Cookies, das den Session-Token traegt (HttpOnly). */
export const SESSION_COOKIE_NAME = 'gto_session';
/**
 * Name des Cookies, das den CSRF-Token traegt. Bewusst **nicht** HttpOnly:
 * Der Client muss den Wert auslesen und im Header spiegeln koennen
 * (Double-Submit-Verfahren).
 */
export const CSRF_COOKIE_NAME = 'gto_csrf';
/** Header, in dem der Client den CSRF-Token zuruecksenden muss. */
export const CSRF_HEADER_NAME = 'x-csrf-token';
/**
 * Maschinenlesbare Fehlercodes der Auth-Endpunkte.
 *
 * `invalid_credentials` wird bewusst **sowohl** bei unbekanntem Benutzer als
 * auch bei falschem Passwort verwendet - die Antwort darf nicht verraten,
 * welches von beidem zutrifft.
 */
export const AUTH_ERROR_CODES = [
    'invalid_credentials',
    'unauthenticated',
    'csrf_failed',
    'rate_limited',
    'invalid_request',
];
/** Type-Guard fuer {@link SessionUser}. */
export function isSessionUser(value) {
    if (typeof value !== 'object' || value === null)
        return false;
    const candidate = value;
    return typeof candidate.id === 'string' && typeof candidate.username === 'string';
}
/** Type-Guard fuer {@link AuthErrorResponse}. */
export function isAuthErrorResponse(value) {
    if (typeof value !== 'object' || value === null)
        return false;
    const candidate = value;
    return (typeof candidate.error === 'string' &&
        AUTH_ERROR_CODES.includes(candidate.error) &&
        typeof candidate.message === 'string');
}
//# sourceMappingURL=auth.js.map